/**
 * Router state a record link leaves behind, so the record's Back returns to the page the
 * link was on - the fixtures search that led to a venue status, say - rather than to
 * the record's own list. A link opened in a new tab carries none, and falls back to it.
 */
export interface RecordLinkState {
  returnTo: string;
}

/** The page the link was pressed on, read at the press so it holds the current search. */
export function fillRecordLinkState(state: RecordLinkState) {
  state.returnTo = `${window.location.pathname}${window.location.search}`;
}

/** Where the record was opened from, if it was opened from a record link. */
export function readReturnTo(state: unknown): string | undefined {
  const returnTo = (state as Partial<RecordLinkState> | null)?.returnTo;

  return typeof returnTo === "string" && returnTo.startsWith("/") ? returnTo : undefined;
}
